/* HAND-SHAPED — gloves landing page behavior.
   Field guide pins, break-in slider, size finder + live add-to-cart, waitlist hand-off. */
(function () {
  'use strict';
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- field guide ---------- */
  var anat = $('[data-glp-anatomy]');
  if (anat) {
    var parts = $$('[data-part]', anat);
    var panels = $$('[data-part-panel]', anat);
    var num = $('[data-part-num]', anat);
    var part = 0;
    var setPart = function (i) {
      part = (i + panels.length) % panels.length;
      parts.forEach(function (b) {
        var on = Number(b.getAttribute('data-part')) === part;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.hidden = Number(p.getAttribute('data-part-panel')) !== part; });
      if (num) num.textContent = '0' + (part + 1);
    };
    parts.forEach(function (b) {
      b.addEventListener('click', function () { setPart(Number(b.getAttribute('data-part'))); });
    });
    $$('[data-part-step]', anat).forEach(function (b) {
      b.addEventListener('click', function () { setPart(part + Number(b.getAttribute('data-part-step'))); });
    });
  }

  /* ---------- break-in slider ---------- */
  var breakin = $('[data-glp-breakin]');
  if (breakin) {
    var range = $('[data-day-range]', breakin);
    var dayNum = $('[data-day-num]', breakin);
    var stages = $$('[data-stage]', breakin);
    var imgs = $$('[data-stage-img]', breakin);
    var stops = $$('[data-day]', breakin);
    var current = -1;
    var stageFor = function (d) { return d >= 90 ? 4 : d >= 60 ? 3 : d >= 30 ? 2 : d >= 12 ? 1 : 0; };
    var setDay = function (d) {
      d = Math.max(1, Math.min(90, Math.round(d)));
      var st = stageFor(d);
      if (range) {
        range.value = d;
        range.style.setProperty('--pct', (((d - 1) / 89) * 100).toFixed(1) + '%');
        range.setAttribute('aria-valuetext', 'Day ' + d);
      }
      if (dayNum) dayNum.textContent = d;
      if (st !== current) {
        current = st;
        stages.forEach(function (s) { s.hidden = Number(s.getAttribute('data-stage')) !== st; });
        imgs.forEach(function (im) { im.classList.toggle('is-on', Number(im.getAttribute('data-stage-img')) === st); });
        stops.forEach(function (b, i) {
          b.classList.toggle('is-on', i === st);
          b.setAttribute('aria-pressed', i === st ? 'true' : 'false');
        });
      }
    };
    if (range) range.addEventListener('input', function () { setDay(Number(range.value)); });
    stops.forEach(function (b) { b.addEventListener('click', function () { setDay(Number(b.getAttribute('data-day'))); }); });
    setDay(range ? Number(range.value) : 1);
    // warm the later photos once the section is close, so the swap is instant
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          imgs.forEach(function (im) { im.loading = 'eager'; });
          io.disconnect();
        }
      }, { rootMargin: '600px 0px' });
      io.observe(breakin);
    }
  }

  /* ---------- size finder + buy ---------- */
  var buy = $('[data-glp-buy]');
  if (!buy) return;
  var form = $('[data-glp-form]', buy);
  var sizeBtns = $$('[data-size-idx]', buy);
  if (!form || !sizeBtns.length) return;

  var variantInput = $('[data-glp-variant]', form);
  var cta = $('[data-glp-cta]', form);
  var msg = $('[data-glp-msg]', form);
  var pills = $('[data-glp-pills]', form);
  var waitlist = $('[data-glp-waitlist]', buy);
  var resEmpty = $('[data-result-empty]', buy);
  var resFull = $('[data-result-full]', buy);
  var resKey = $('[data-result-key]', buy);
  var resInch = $('[data-result-inch]', buy);
  var resStatus = $('[data-result-status]', buy);
  var price = buy.getAttribute('data-price') || '';
  var productId = buy.getAttribute('data-product-id');
  var cartAdd = (buy.getAttribute('data-cart-add') || '/cart/add').replace(/\/$/, '');
  var cartUrl = buy.getAttribute('data-cart') || '/cart';
  var selected = null;
  var busy = false;

  var ICON = {
    in: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    clock: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    mail: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5L12 13l8.5-6.5"/></svg>'
  };

  var sizeData = function (btn) {
    return {
      idx: Number(btn.getAttribute('data-size-idx')),
      id: btn.getAttribute('data-variant-id'),
      key: btn.getAttribute('data-key'),
      name: btn.getAttribute('data-name'),
      inch: btn.getAttribute('data-inch'),
      state: btn.getAttribute('data-state'),
      low: Number(btn.getAttribute('data-low') || 0)
    };
  };

  var showMsg = function (text) {
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
  };

  var statusHtml = function (s) {
    if (s.state === 'out') return { cls: 'out', html: ICON.mail + 'Sold out — get an email when it’s back' };
    if (s.state === 'pre') return { cls: 'pre', html: ICON.clock + 'Pre-order — ships with the next small run' };
    if (s.state === 'low') return { cls: 'low', html: ICON.clock + 'Only ' + s.low + ' left in this size' };
    return { cls: 'in', html: ICON.in + 'In stock and ready to ship' };
  };

  var setSize = function (idx) {
    var btn = sizeBtns.filter(function (b) { return Number(b.getAttribute('data-size-idx')) === idx; })[0];
    if (!btn) return;
    selected = sizeData(btn);
    sizeBtns.forEach(function (b) {
      var on = Number(b.getAttribute('data-size-idx')) === idx;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    variantInput.value = selected.id;
    showMsg('');

    // result card
    if (resEmpty) resEmpty.hidden = true;
    if (resFull) resFull.hidden = false;
    if (resKey) resKey.textContent = selected.key;
    if (resInch) resInch.textContent = selected.inch;
    if (resStatus) {
      var st = statusHtml(selected);
      resStatus.className = 'glp-status glp-status--' + st.cls;
      resStatus.innerHTML = st.html;
    }

    // CTA + waitlist
    var out = selected.state === 'out';
    if (out) {
      cta.textContent = 'Size ' + selected.key + ' is sold out';
      cta.disabled = true;
    } else {
      cta.disabled = false;
      cta.textContent = (selected.state === 'pre' ? 'Pre-order size ' : 'Add size ') + selected.key + (selected.state === 'pre' ? '' : ' to cart') + ' — ' + price;
    }
    if (waitlist) waitlist.hidden = !out;
    try {
      document.dispatchEvent(new CustomEvent('rarely:demand:variant-change', {
        detail: { productId: productId, variantId: selected.id }
      }));
    } catch (e) { /* old browsers: waitlist keeps its own select */ }
  };

  sizeBtns.forEach(function (b) {
    b.addEventListener('click', function () { setSize(Number(b.getAttribute('data-size-idx'))); });
  });

  // nav / hero CTAs land on the card
  $$('[data-glp-jump]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var card = document.getElementById('buy');
      if (!card) return;
      e.preventDefault();
      card.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#buy');
    });
  });

  var nudge = function () {
    if (!pills) return;
    pills.classList.remove('is-nudge');
    void pills.offsetWidth;
    pills.classList.add('is-nudge');
    var first = pills.querySelector('button:not(.is-out)') || pills.querySelector('button');
    if (first) first.focus({ preventScroll: true });
  };

  form.addEventListener('submit', function (e) {
    if (!selected) { e.preventDefault(); showMsg('Pick a size first — tap one above.'); nudge(); return; }
    if (selected.state === 'out') { e.preventDefault(); return; }
    if (!window.fetch) return; // plain form post to the cart
    e.preventDefault();
    if (busy) return;
    busy = true;
    var label = cta.textContent;
    cta.disabled = true;
    cta.textContent = 'Adding…';
    fetch(cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(selected.id), quantity: 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (r) {
      if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not add to cart');
      cta.textContent = 'Added — heading to your cart';
      window.location.href = cartUrl;
    }).catch(function (err) {
      busy = false;
      cta.disabled = false;
      cta.textContent = label;
      showMsg(err && err.message ? err.message : 'Something went wrong. Please try again.');
    });
  });
})();
